import LandingPage from "@/views/LandingPage/Index";

export default [
  {
    path: "/pricing",
    name: "pricing",
    component: () =>
      import(/* webpackChunkName: "pricing" */ "@/views/LandingPage/Pricing"),
    meta: {
      guest: true
    }
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: () =>
      import(/* webpackChunkName: "signIn" */ "@/views/Registry/SignIn"),
    meta: {
      guest: true
    }
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: () =>
      import(/* webpackChunkName: "signUp" */ "@/views/Registry/SignUp"),
    meta: {
      guest: true
    }
  },
  {
    path: "/verify-token",
    name: "verify-token",
    component: () =>
      import(
        /* webpackChunkName: "emailVerification" */ "@/views/Verification/Email"
      ),
    meta: {
      anyUser: true
    }
  },
  {
    path: "/sales/shared",
    name: "shared-sale",
    component: () =>
      import(/* webpackChunkName: "sharedSale" */ "@/views/Sales/Shared"),
    meta: {
      anyUser: true
    }
  },
  {
    path: "/orders/shared",
    name: "shared-order",
    component: () =>
      import(/* webpackChunkName: "sharedSale" */ "@/views/Orders/Shared"),
    meta: {
      anyUser: true
    }
  },
  {
    path: "/",
    name: "home",
    component: LandingPage,
    meta: {
      guest: true
    }
  }
];
